<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qo8prr/tc-custom/9781526751089.jpg?1712901124431" alt="This image is the cover for the book From Robber Barons to Courtiers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">From Robber Barons to Courtiers
      </h1>
      <p class="bookDescription body article font2">
        <p>Francis Lovell is without a doubt the most famous - if not the only famous - Lovell of Titchmarsh. In 1483 he was he was made a viscount by Edward IV, the first Lovell to be raised into the titled nobility. He is most famous for being the chamberlain and close friend of Richard III, the 'dog' of William Collingbourne's famous doggerel.  Though Francis Lovell is the best known member of his family, the Lovells were an old aristocratic family, tracing their roots back to eleventh-century Normandy. Aside from the Battle of Hastings, a Lovell can be found at virtually all important events in English history, whether it was the crusade of Richard I, the Battle of Lewes, the siege of Calais, the Lambert Simnel rebellion against Henry VII, or the downfall of Anne Boleyn. Over the centuries the Lovells rose in wealth and power through service to the crown, rich marriages, and, to a considerable degree, luck.  The history of the Lovells of Titchmarsh, from their relatively obscure beginnings in the border region between France and Normandy to a powerful position at the royal court, not only illustrates the fate of this one family but also throws an interesting light on the changes and developments in medieval and Tudor England. Several themes emerge as constant in the lives of an aristocratic family over the five centuries covered in this book: the profit and perils of service to the crown, the influences of family tradition and personal choice, loyalty and opportunism, skill and luck, and the roles of women in the family.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Monika E. Simon
      </h2>
      
      <p class="authorDescription body article">Monika E. Simon studied Medieval History, Ancient History, and English Linguistics and Middle English Literature at the Ludwig-Maximilians-Universität, Munich from which she received an MA. She wrote her DPhil thesis about the Lovells of Titchmarsh at the University of York. She lives and works in Munich.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword History
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?19f9daf6